import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

interface TabPanelProps {
  index: number;
  value: number;
}

const useStyles = makeStyles(() => ({
  noLateralPadding: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
}));

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  index,
  value,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.noLateralPadding}>
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...rest}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    </Container>
  );
};

export default TabPanel;
